import { FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { datadogRum } from "@datadog/browser-rum";

const DataDogRum: FC = () => {
    const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
    const rumUserName = useRef<number | null>(null);

    useEffect(() => {
        if (typeof(user) !== 'undefined' && user !== null && rumUserName.current !== user?.userName) {
            const enterprise = window.location.hostname === 'localhost'
                            ? localStorage.getItem('realm')
                            : window.location.hostname.split('-')[0]
            datadogRum.setUser({ name: user.userName, role: user.currentRoles, organization: enterprise });
            rumUserName.current = user.userName;
        }
    }, [user]);
    return <span id="data-dog-rum"></span>
};

export default DataDogRum;